import React from 'react';

export interface TuningOption {
  value: string;
  label: string;
}

interface TuningSelectorProps {
  value: string;
  onChange: (next: string) => void;
  options: TuningOption[];
  disabled?: boolean;
}

const TuningSelector: React.FC<TuningSelectorProps> = ({ value, onChange, options, disabled = false }) => (
  <div className={`flex rounded-xl overflow-hidden border border-gray-200 ${disabled ? 'opacity-50' : ''}`}>
    {options.map((opt, idx) => {
      const selected = opt.value === value;
      return (
        <button
          key={opt.value}
          type="button"
          disabled={disabled}
          onClick={() => { if (!disabled && !selected) onChange(opt.value); }}
          className={`flex-1 py-2.5 text-sm font-semibold transition-all ${idx > 0 ? 'border-l border-gray-200' : ''} ${
            selected
              ? 'bg-gradient-to-b from-amber-400 to-amber-500 text-white shadow-inner'
              : 'bg-gray-50 text-gray-500 hover:bg-gray-100'
          } ${disabled ? 'cursor-not-allowed' : ''}`}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export default TuningSelector;
